import axios from '../axios'

// クイズ受験の提出。answers = [{ question_id, option_id?, text? }, ...]
const postQuizAttemptApi = async (quizId, answers) => {
  return await axios.post(`api/lms/quizzes/${quizId}/attempts`, { answers })
}

export default postQuizAttemptApi
